import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";

/**
 * This function encapsulates date that is currently stored in redux but should
 * be migrated to a different mechanism. The domain country code does not change
 * over the course of the page lifecycle, so does not need to be stored in redux.
 */
export default () => useSelector(getDomainCountryCode);
